import React, { useMemo } from "react";
import { Document, Page, Text, View, Image, StyleSheet, Font } from "@react-pdf/renderer";
import sitlogo from '../../assets/images/sitlogo.png';

const StandardLecturePlanDoc = ({ standarddata }) => {
    Font.register({
        family: 'Poppins',
        fonts: [
            {
                src: '/fonts/Poppins-Regular.ttf',
                fontWeight: 'normal',
            },
            {
                src: '/fonts/Poppins-SemiBold.ttf',
                fontWeight: 600,
            },
            {
                src: '/fonts/Poppins-Bold.ttf',
                fontWeight: 'bold',
            },
        ],
    });

    const studentdata = Array.isArray(standarddata) ? standarddata : [];
    const chunkArray = (array, size) => {
        const result = [];
        for (let i = 0; i < array.length; i += size) {
            result.push(array.slice(i, i + size));
        }
        return result;
    };
    const pages = useMemo(() => chunkArray(studentdata, 8), [studentdata]);

    return (
        <Document>
            {pages.map((pageData, pageIndex) => (
                <Page size="A4" orientation="landscape" style={{ padding: 30, paddingLeft: 70, fontSize: 10 }}>

                    {/* Logo View */}
                    <View style={{ flexDirection: "column", alignItems: "flex-start" }}>
                        <Image src={sitlogo} style={{ width: 70 }} />
                    </View>

                    <View style={{
                        width: "100%",
                        height: '20px',
                        top: "4px",
                        border: "2px solid black",
                        justifyContent: "center",
                        alignItems: 'center'
                    }}>
                        <Text style={{
                            fontSize: 10, fontWeight: 600, fontFamily: 'Poppins'
                        }}>STANDARAD LECTURE PLAN & DETAILS</Text>
                    </View>

                    <View style={{ width: "100%", height: "82%", border: '2px solid black', marginTop: 10, flexDirection: "column" }}>
                        <View style={{ width: "100%", height: "5%", borderBottom: "1px solid black", flexDirection: "row" }}>
                            <View style={{ width: "16%", height: "100%", justifyContent: "center", alignItems: "flex-start", paddingLeft: 4 }}>
                                <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                    Training Programme : </Text>
                            </View>
                            <View style={{ width: "35%", height: "100%", justifyContent: "center", alignItems: "flex-start", paddingLeft: 4 }}>
                                <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                    Piping Engineering </Text>
                            </View>
                            <View style={{ width: "8%", height: "100%", justifyContent: "center", alignItems: "flex-start", paddingLeft: 4 }}>
                                <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                    Batch No : </Text>
                            </View>
                            <View style={{ width: "18%", height: "100%", justifyContent: "center", alignItems: "flex-start", paddingLeft: 4 }}>
                                <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                    01160 </Text>
                            </View>
                            <View style={{ width: "8%", height: "100%", justifyContent: "center", alignItems: "flex-start", paddingLeft: 4 }}>
                                <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                    Category : </Text>
                            </View>
                            <View style={{ width: "12%", height: "100%", justifyContent: "center", alignItems: "flex-start", paddingLeft: 4 }}>
                                <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                    Full Time </Text>
                            </View>
                        </View>

                        <View style={{ width: "100%", height: "10%", borderBottom: "1px solid black", flexDirection: "row" }}>
                            <View style={{ width: "6%", height: "100%", borderRight: "1px solid black", justifyContent: "center", alignItems: "center", paddingLeft: 4, flexDirection: "column" }}>
                                <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                    Lecture </Text>
                                <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                    No. </Text>
                            </View>
                            <View style={{ width: "7%", height: "100%", borderRight: "1px solid black", justifyContent: "center", alignItems: "center", paddingLeft: 4, flexDirection: "column" }}>
                                <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                    Planned </Text>
                                <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                    Date </Text>
                            </View>
                            <View style={{ width: "7%", height: "100%", borderRight: "1px solid black", justifyContent: "center", alignItems: "center", paddingLeft: 4, flexDirection: "column" }}>
                                <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                    Planned </Text>
                                <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                    Time </Text>
                            </View>
                            <View style={{ width: "28%", height: "100%", borderRight: "1px solid black", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                                <View style={{ width: "100%", height: "50%", justifyContent: "center", alignItems: "center", borderBottom: "1px solid black" }}>
                                    <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                        Lecture Content in Detail </Text>
                                </View>
                                <View style={{ width: "100%", height: "50%", flexDirection: "row" }}>
                                    <View style={{ width: "50%", height: '100%', justifyContent: "center", alignItems: "center", borderRight: "1px solid black" }}>
                                        <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                            Topic </Text>
                                    </View>
                                    <View style={{ width: "50%", height: '100%', justifyContent: "center", alignItems: "center" }}>
                                        <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                            Sub Topic </Text>
                                    </View>
                                </View>

                            </View>
                            <View style={{ width: "11%", height: "100%", borderRight: "1px solid black", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                                <View style={{ width: "100%", height: "50%", justifyContent: "center", alignItems: "center", borderBottom: "1px solid black" }}>
                                    <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                        Assignment </Text>
                                </View>
                                <View style={{ width: "100%", height: "50%", justifyContent: "center", alignItems: "center" }}>
                                    <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                        Test </Text>


                                </View>

                            </View>

                            <View style={{ width: "12%", height: "100%", borderRight: "1px solid black", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                                <View style={{ width: "100%", height: "100%", justifyContent: "center", alignItems: "center", }}>
                                    <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                        Documents /</Text>
                                    <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                        Actual Photocopy/ </Text>
                                    <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                        LCD Required </Text>
                                </View>

                            </View>
                            <View style={{ width: "14%", height: "100%", borderRight: "1px solid black", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                                <View style={{ width: "100%", height: "100%", justifyContent: "center", alignItems: "center", }}>
                                    <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                        Faculty</Text>

                                </View>

                            </View>
                            <View style={{ width: "7.5%", height: "100%", borderRight: "1px solid black", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                                <View style={{ width: "100%", height: "50%", justifyContent: "center", alignItems: "center", borderBottom: "1px solid black" }}>
                                    <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                        Actual </Text>
                                </View>
                                <View style={{ width: "100%", height: "50%", justifyContent: "center", alignItems: "center" }}>
                                    <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                        Date </Text>


                                </View>

                            </View>
                            <View style={{ width: "7.5%", height: "100%", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                                <View style={{ width: "100%", height: "50%", justifyContent: "center", alignItems: "center", borderBottom: "1px solid black" }}>
                                    <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                        Actual </Text>
                                </View>
                                <View style={{ width: "100%", height: "50%", justifyContent: "center", alignItems: "center" }}>
                                    <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                        Time </Text>


                                </View>

                            </View>


                        </View>
                        {pageData.map((item, i) => (
                            <View style={{ width: "100%", height: "17%", borderBottom: "1px solid black", flexDirection: "row" }}>
                                <View style={{ width: "6%", height: "100%", borderRight: "1px solid black", justifyContent: "center", alignItems: "center", paddingLeft: 4, flexDirection: "column" }}>
                                    <Text style={{ fontSize: 8.5, fontFamily: 'Poppins' }}>
                                        {item.lecture_no} </Text>

                                </View>
                                <View style={{ width: "7%", height: "100%", borderRight: "1px solid black", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                                    <View style={{ width: "100%", height: "50%", justifyContent: "center", alignItems: "center", borderBottom: "1px solid black" }}>
                                        <Text style={{ fontSize: 8.5, fontFamily: 'Poppins' }}>
                                            {item.lectureday} </Text>
                                    </View>
                                    <View style={{ width: "100%", height: "50%", justifyContent: "center", alignItems: "center" }}>
                                        <Text style={{ fontSize: 8.5, fontFamily: 'Poppins' }}>
                                            {item.planned} </Text>
                                    </View>
                                </View>
                                <View style={{ width: "7%", height: "100%", borderRight: "1px solid black", justifyContent: "center", alignItems: "center", paddingLeft: 4, flexDirection: "column" }}>
                                    <Text style={{ fontSize: 8.5, fontFamily: 'Poppins' }}>
                                        {item.starttime} </Text>
                                    <Text style={{ fontSize: 8.5, fontFamily: 'Poppins' }}>
                                        To </Text>
                                    <Text style={{ fontSize: 8.5, fontFamily: 'Poppins' }}>
                                        {item.endtime} </Text>
                                </View>
                                <View style={{ width: "28%", height: "100%", borderRight: "1px solid black", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                                    <View style={{ width: "100%", height: "100%", flexDirection: "row" }}>
                                        <View style={{ width: "50%", height: '100%', alignItems: "flex-start", borderRight: "1px solid black", paddingLeft: 4, paddingTop: 2 }}>
                                            <Text style={{ fontSize: 8.5, fontFamily: 'Poppins' }}>
                                                {item.Topic} </Text>
                                        </View>
                                        <View style={{ width: "50%", height: '100%', alignItems: "flex-start", paddingLeft: 4, paddingTop: 2 }}>
                                            <Text style={{ fontSize: 8.5, fontFamily: 'Poppins' }}>
                                                {item.Topic} </Text>
                                        </View>
                                    </View>

                                </View>
                                <View style={{ width: "11%", height: "100%", borderRight: "1px solid black", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                                    <View style={{ width: "100%", height: "50%", justifyContent: "center", alignItems: "center", borderBottom: "1px solid black" }}>
                                        <Text style={{ fontSize: 8.5, fontFamily: 'Poppins' }}>
                                        </Text>
                                    </View>
                                    <View style={{ width: "100%", height: "50%", justifyContent: "center", alignItems: "center" }}>
                                        <Text style={{ fontSize: 8.5, fontFamily: 'Poppins' }}>
                                        </Text>


                                    </View>

                                </View>

                                <View style={{ width: "12%", height: "100%", borderRight: "1px solid black", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                                    <View style={{ width: "100%", height: "100%", justifyContent: "center", alignItems: "center", }}>
                                        <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                            {item.Documents_Required}
                                        </Text>
                                    </View>

                                </View>
                                <View style={{ width: "14%", height: "100%", borderRight: "1px solid black", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                                    <View style={{ width: "100%", height: "100%", justifyContent: "center", alignItems: "center", }}>
                                        <Text style={{ fontSize: 8.5, fontFamily: 'Poppins' }}>
                                           {item.Faculty_Name}</Text>

                                    </View>

                                </View>
                                <View style={{ width: "7.5%", height: "100%", borderRight: "1px solid black", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                                    <View style={{ width: "100%", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                        <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                            {item.Take_Dt} </Text>
                                    </View>


                                </View>
                                <View style={{ width: "7.5%", height: "100%", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                                    <View style={{ width: "100%", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                        <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
                                            {item.Lecture_Start} to {item.Lecture_End} </Text>
                                    </View>


                                </View>


                            </View>
                        ))}
                    </View>




                    {/* FOOTER */}
                    < View style={{ width: "100%", height: "20px", flexDirection: 'row', marginTop: 2 }}>
                        <View style={{ width: "10%", justifyContent: 'center', height: '100%' }}>
                            <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins', paddingTop: 1 }}>
                                F/006B/04
                            </Text>
                        </View>
                        <View style={{ width: "30%", height: '100%', justifyContent: 'center', flexDirection: "row" }}>
                            <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins', width: "25%", paddingTop: 4 }}>
                                Prepared By
                            </Text>
                            <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins', borderBottom: "1px solid black", width: "60%" }}>

                            </Text>
                        </View>
                        <View style={{ width: "30%", height: '100%', justifyContent: 'center', flexDirection: "row" }}>
                            <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins', width: "25%", paddingTop: 4 }}>
                                Checked By
                            </Text>
                            <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins', borderBottom: "1px solid black", width: "60%" }}>

                            </Text>
                        </View>
                        <View style={{ width: "30%", height: '100%', justifyContent: 'center', flexDirection: "row" }}>
                            <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins', width: "25%", paddingTop: 4 }}>
                                Approved By
                            </Text>
                            <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins', borderBottom: "1px solid black", width: "60%" }}>

                            </Text>
                        </View>
                    </View>

                </Page>
            ))
            }
        </Document >
    );
};

export default StandardLecturePlanDoc;
